import OpenXShortLogo from './assets/logo_x.svg?url';
import { LogoBox } from './LogoBox.tsx';

export function OpenXLogo(): JSX.Element {
  return (
    <LogoBox>
      <img src={OpenXShortLogo} style={{ height: '26px' }} alt="OpenX Logo" />
    </LogoBox>
  );
}
